import { render, staticRenderFns } from "./OrederDetails.vue?vue&type=template&id=3f8da868"
import script from "./OrederDetails.vue?vue&type=script&lang=js"
export * from "./OrederDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports